'use strict';

angular.module('licensure.portal')
    .directive('portalOfflineTop', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'components/offline-top/offline-top.html',
            replace: true,
            link: function (scope, elem, attrs, ctrl) {
            }
        };
    }])
;